// extracted by mini-css-extract-plugin
export default {"loader":"loader__vKlVt","list":"list__s1RuL"};